import {
    type AddressVerificationIssue,
    type AddressVerificationResult
} from "@/types/loqate/verify"

/**
 * The one issue the customer cannot wave through, because the carrier will not deliver it.
 * Everything else, an unfound premise included, is Loqate failing to confirm the address
 * rather than proof it is fake — and refusing a real one costs the whole order.
 */
const BLOCKING_ISSUE_CODES: ReadonlySet<AddressVerificationIssue["code"]> = new Set([
    "po_box_not_allowed"
])

export const canUseAddressAsEntered = (result: AddressVerificationResult): boolean =>
    result.decision === "fix" &&
    !result.issues.some(item => BLOCKING_ISSUE_CODES.has(item.code))
